import { useIntl } from 'react-intl';
import { Loader, Switch, useQueryFetch } from 'sonata-react-components';

import { SharedMap } from '@/components/SharedMap/SharedMap';
import { fetchSharedMap } from './sharedMap.resources';

import './index.scss';

function getTokenFromHash(): string | null {
  const hash = window.location.hash.replace(/^#/, '');
  return hash || null;
}

export default function SharedMapPage(): JSX.Element {
  const { formatMessage } = useIntl();
  const token = getTokenFromHash();

  const { data, errorMsg, status } = useQueryFetch([`sharedMap_${token}`, token], () => fetchSharedMap(token!), {
    enabled: !!token
  });

  const hasError = !token || !!errorMsg;

  return (
    <div className="sharedMap__container">
      <Switch>
        <Switch.Case condition={status === 'success' && Boolean(data)}>
          <SharedMap data={data} hasError={hasError} />
        </Switch.Case>
        <Switch.Case condition={status === 'loading'}>
          <Loader id={'public_sharedMap'} type="layer-processing" variant="default">
            <Loader.Title>
              {formatMessage({
                defaultMessage: 'Preparing your map, this may take a few seconds...',
                id: 'public.sharedMap.loading'
              })}
            </Loader.Title>
          </Loader>
        </Switch.Case>
        <Switch.Case condition={hasError}>
          <div className="sharedMap__error">
            {formatMessage({
              defaultMessage: 'The map you are trying to access is not available.',
              id: 'public.sharedMap.error'
            })}
          </div>
        </Switch.Case>
      </Switch>
    </div>
  );
}
